import React from 'react'
import classNames from 'classnames'

import { withAngleClasses } from '../../helpers/with-angle'
import style from './index.module.scss'

export enum AngleType {
  topLeft = 'top-left',
  topRight = 'top-right',
  bottomLeft = 'bottom-left',
  bottomRight = 'bottom-right',
}

const Comp: React.FC<{
  angleClasses: any
  className?: string
  angleType?: AngleType
}> = ({
  angleClasses,
  className,
  children,
  angleType = AngleType.bottomLeft,
}) => (
  <div
    aria-hidden="true"
    className={classNames([
      style.background,
      angleClasses[angleType],
      className,
    ])}
  >
    {children}
  </div>
)

export const AngleBackground = withAngleClasses(Comp)
